import type { FC } from 'react';
import React from 'react';

import { Box, Stack, xcss } from '@atlaskit/primitives';

// Skeleton
const baseSkeletonStyles = xcss({
	backgroundColor: 'color.background.accent.gray.subtlest',
	borderRadius: 'border.radius.200',
});
const headerSkeletonStyles = xcss({
	height: '20px',
	width: '100px',
});
const descriptionSkeletonStyles = xcss({
	marginTop: 'space.150',
	height: '12px',
	width: '720px',
});
const subheadingSkeletonStyles = xcss({
	marginTop: 'space.500',
	height: '8px',
	width: '100px',
});
const bodySkeletonStyles = xcss({
	marginTop: 'space.050',
	height: '36px',
	width: '240px',
	borderRadius: 'border.radius.100',
});

const SkeletonTemplate: FC = () => (
	<Stack space="space.050">
		<Box xcss={[baseSkeletonStyles, headerSkeletonStyles]} />
		<Box xcss={[baseSkeletonStyles, descriptionSkeletonStyles]} />
		<Stack space="space.050">
			<Box xcss={[baseSkeletonStyles, subheadingSkeletonStyles]} />
			<Box xcss={[baseSkeletonStyles, bodySkeletonStyles]} />
		</Stack>
	</Stack>
);

export const SinglePageFormSkeleton: FC<{ testId?: string }> = ({ testId }) => {
	return (
		<Stack space="space.500" testId={testId}>
			<SkeletonTemplate />
			<SkeletonTemplate />
		</Stack>
	);
};
